<template>
  <div class="three-dim-multipal-player video w-full h-full flex flex-wrap relative">
    <div class="forVideo" :style="`width:100%;height: 100%;display:flex;flex-wrap:wrap`"></div>
    <CameraPicture
      :deviceCode="deviceCode"
      :plid="plid"
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px"
    ></CameraPicture>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const CameraPicture = () => {
  return import('../../smartSecurity/cameraPicture')
}
const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()

export default {
  components: {
    CameraPicture,
  },
  props: {
    code: {
      type: Array,
      default: () => [],
    },
    // 9宫格 | 4宫格
    typeNum: {
      type: Number,
      default: 2,
    },
    // code是否首次传值进来
    isCodeFirstInit: {
      type: Boolean,
      default: true,
    },
    // 切换的次数属于基数或偶数，用1、0表示
    evenOrOdd: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    code: {
      handler() {
        // 避免首次进来加载两次视频
        if (!this.isCodeFirstInit) {
          this.switchVideo()
          this.counter += 1
          if (this.counter > 3) {
            this.counter = 3
          }
        }
      },
      deep: true,
    },
    typeNum() {
      if (this.loginSuccess) {
        this.creatVideo()
      }
    },
  },
  mounted() {
    this.getConfig()
  },
  data() {
    return {
      domArr: [],
      ipAddress: '',
      username: '',
      password: '',
      port: '',
      idArr: [],
      boon: 0,
      timer: null,
      counter: 1,
      isShowDialog: false,
      deviceCode: '',
      plid: '',
      loginSuccess: false,
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    // 把typeNum-(typeNum * 2 - 1)窗口（从0开始）切换到可见, 隐藏前面typeNum个窗口， index范围是typeNum-(typeNum * 2 - 1)
    operateOddVideoDisplay(index) {
      // 前typeNum个窗口的z-index固定，只需改变后面typeNum个的z-index，即可实现显示与隐藏
      this.domArr[index].dom.style.zIndex = 10
      this.domArr[index - this.typeNum].dom.style.zIndex = -5
      this.domArr[index - this.typeNum].success = false
    },
    // 把0-(typeNum-1)窗口（从0开始）切换到可见, 隐藏后面typeNum个窗口， index范围是0-(typeNum-1)
    operateEvenVideoDisplay(index) {
      // 前typeNum个窗口的z-index固定，只需改变后面typeNum个的z-index，即可实现显示与隐藏
      this.domArr[index].dom.style.zIndex = 10
      this.domArr[index + this.typeNum].dom.style.zIndex = -5
      this.domArr[index + this.typeNum].success = false
    },
    // 切换视频
    switchVideo() {
      let firstWindowArr = []
      let firstIndex = 0
      while (firstIndex < this.typeNum) {
        firstWindowArr.push(firstIndex)
        firstIndex++
      }
      let nextWindowArr = []
      let nextIndex = this.typeNum
      while (nextIndex < this.typeNum * 2) {
        nextWindowArr.push(nextIndex)
        nextIndex++
      }
      // 如果是切换的次数是偶数，即0（用0、1表示偶数，奇数）
      if (this.evenOrOdd === 0) {
        // evenOrOdd = 0，表示把typeNum-(typeNum * 2 - 1)的窗口属性display改成block
        nextWindowArr.forEach((item) => {
          if (this.domArr[item] && this.domArr[item].success) {
            this.operateOddVideoDisplay(item)
          }
        })

        if (this.counter === 1) {
          // 用来解决第一次切换，后四个视频无法覆盖前四个视频问题
          this.$forceUpdate()
        }
        // 把新传进来的code进行预加载,即预加载0-(typeNum-1)窗口
        firstWindowArr.forEach((el) => {
          // 在第typeNum个窗口成功播放时，如果第0个窗口没有预加载成功，那么在下一轮不再预加载第typeNum个窗口，否则会出现加载的loading
          if (this.domArr[el] && this.domArr[el].success === false) {
            this.replaceIdArrAndPlayLive(this.domArr[el].iframeObj.id, this.code[el], el)
          }
        })
      } else {
        // evenOrOdd = 1，表示把0-(typeNum-1)的窗口属性display改成block
        firstWindowArr.forEach((item) => {
          if (this.domArr[item] && this.domArr[item].success) {
            this.operateEvenVideoDisplay(item)
          }
        })

        // 把新传进来的code进行预加载,即预加载typeNum-(typeNum * 2 - 1)窗口
        nextWindowArr.forEach((el) => {
          if (this.domArr[el] && this.domArr[el].success === false) {
            this.replaceIdArrAndPlayLive(this.domArr[el].iframeObj.id, this.code[el - typeNum], el)
          }
        })
      }
    },
    async getConfig() {
      const pIid = _.get(this.code[0], 'pIid') // 电视墙重复渲染问题 取监控列表的第一条数据的pIid获取config
      const [err, res] = await iotDeviceProtocolInstanceApi.get(pIid)
      if (!err) {
        const parsedInfo = JSON.parse(res.jsonContent)
        // 此处模拟请求
        // const parsedInfo = JSON.parse(
        //   '{"UserName":"loadmin","PassWord":"*Ab123456","IP":"imos.wiz.top","Port":"8088"}'
        // ) // 模拟
        this.ipAddress = parsedInfo.IP
        this.username = parsedInfo.UserName
        this.password = parsedInfo.PassWord
        this.port = parsedInfo.Port
        this.login()
      } else {
        this.ipAddress = ''
        this.username = ''
        this.password = ''
        this.port = ''
      }
    },
    async login() {
      const _this = this
      const apiUrl = `http://${this.ipAddress}:${this.port}/VIID/login/v2`
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          }
          throw new Error('网络请求失败')
        })
        .then((res) => {
          const accessCode = res.AccessCode
          const md2 = forge.md.md5.create() // md5
          const base64Username = window.btoa(this.username)
          const loginSignatureTemp = base64Username + accessCode + this.password
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          const data = {
            UserName: this.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          const requestOpion2 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify(data),
          }
          fetch(apiUrl, requestOpion2)
            .then((response) => {
              if (response.status === 200) {
                return response.json()
              }
              throw new Error('网络请求失败')
            })
            .then((r) => {
              const loginResult = r.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  console.log('密码错误')
                  break
                case 12351:
                  console.log('用户不存在')
                  break
                case undefined:
                  window.playerToken = r.AccessToken
                  if (_this.timer) {
                    clearTimeout(_this.timer)
                  }
                  _this.keepAliveFn()
                  // 在使用https 的时候设置为https 代理端口号
                  const ishttps = document.location.protocol === 'https:'
                  const url = window.location.host
                  if (ishttps) {
                    imosSdk.setLinkPort('7077')
                  }
                  const vmip = _this.ipAddress
                  imosSdk
                    .init(vmip, window.playerToken, 1, '/unv/imosSdk.html', false)
                    .then(() => {
                      // 设置后续事件回调
                      imosSdk.registerLiveMsg((result) => {
                        if (result.Type === 'error') {
                          console.log(result, '播放结果---error')
                        }
                      })
                    })
                    .then(() => {})
                    .catch((err) => {})
                  break
                default:
                  break
              }
              _this.loginSuccess = true
              _this.creatVideo()
            })
            .catch((e) => {
              console.log('服务器连接异常e:', e)
            })
            .catch((error) => {
              console.log('服务器连接异常error', error)
            })
        })
    },
    creatVideo() {
      const videoDom = document.getElementsByClassName('forVideo')[0]
      videoDom.innerHTML = ''
      this.idArr = []
      this.domArr = []
      this.code.forEach((item, index) => {
        this.creatWindow(item, index)
      })
      // 调用保活接口，方式视频信号丢失
    },
    creatWindow(item, index) {
      if (!window.playerToken) {
        return
      }
      const iframeObj = imosSdk.createPanelWindow()
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        return
      }
      const obj = {
        code: item.code,
        id: iframeObj.id,
        addId: item.id,
      }
      this.idArr.push(obj)
      this.createSpeDiv(iframeObj, item, index)
    },
    createSpeDiv(iframeObj, item, index) {
      const videoDom = document.getElementsByClassName('forVideo')[0]
      let divDom = document.createElement('div')
      // 设置样式
      // 12宫格样式
      if (this.typeNum === 12) {
        divDom.style.height = '32%'
        divDom.style.width = '20%'
        divDom.style.marginLeft = '4%'
        // 6宫格样式
      } else if (this.typeNum === 6) {
        divDom.style.height = '50%'
        divDom.style.width = '31%'
        divDom.style.marginLeft = '1.75%'
        // 4宫格样式
      } else if (this.typeNum === 4) {
        divDom.style.height = '50%'
        divDom.style.width = '48%'
        divDom.style.marginLeft = '2%'
        // 2宫格
      } else if (this.typeNum === 2) {
        divDom.style.height = '100%'
        divDom.style.width = '48%'
        divDom.style.marginLeft = '2%'
      } else if (this.typeNum === 1) {
        divDom.style.height = '100%'
        divDom.style.width = '62%'
        divDom.style.marginLeft = '18%'
      }
      const divDomName = document.createElement('div')
      const arrowDomName = document.createElement('i')
      arrowDomName.className = 'el-icon-right float-right'
      arrowDomName.style.fontSize = '18px'
      arrowDomName.style.lineHeight = '28px'
      arrowDomName.style.color = '#fbff00'
      arrowDomName.style.transform = 'scaleX(5) scaleX(0.3)'
      divDomName.innerHTML = `${item.name}`
      divDomName.appendChild(arrowDomName)
      divDomName.style.fontSize = '12px'
      divDomName.style.color = '#fff'
      divDomName.style.fontWeight = 600
      divDomName.style.textAlign = 'start'
      divDomName.style.padding = '1%'
      divDomName.style.height = '28px'
      divDomName.style.lineHeight = '28px'
      divDomName.style.cursor = 'pointer'
      divDomName.addEventListener('click', () => {
        this.reviewDetail(item)
      })
      divDom.appendChild(iframeObj)
      divDom.appendChild(divDomName)
      videoDom.appendChild(divDom)
      divDom = null
      this.domArr.push({
        index,
        dom: divDom,
        iframeObj,
      })
      this.playLive(iframeObj.id, item, index)
    },
    playLive(iframeId, item, index) {
      if (!window.playerToken) {
        return
      }
      imosSdk.playLive(
        iframeId, // 设置摄像头Id
        item.code, // 设置摄像头code
        item.code, // 设置摄像头code
        (result) => {
          switch (result.ErrCode) {
            case 0:
              this.domArr[index].success = true
              break
            case 55001:
              imosSdk.playLive(
                iframeId, // 设置摄像头Id
                item.code, // 设置摄像头code
                item.code, // 设置摄像头code
                (res) => {
                  console.log('重新播放业务已切换的code: ', this.domArr[index], index, res)
                },
                2
              )
              break
            case 4660:
              imosSdk.playLive(
                iframeId, // 设置摄像头Id
                item.code, // 设置摄像头code
                item.code, // 设置摄像头code
                (res) => {
                  console.log(
                    '重新播放playLive请求失败被终结code: ',
                    this.domArr[index],
                    index,
                    res
                  )
                },
                2
              )
              break
            default:
              this.domArr[index].success = false
              imosSdk.playLive(
                iframeId, // 设置摄像头Id
                item.code, // 设置摄像头code
                item.code, // 设置摄像头code
                (res) => {},
                2
              )
              break
          }
        },
        2
      )
    },
    // 替换this.idArr里面某个元素的值，并且播放视频
    replaceIdArrAndPlayLive(iframeId, item, index) {
      if (!window.playerToken) {
        return
      }
      this.idArr.splice(index, 1, item)
      imosSdk.playLive(
        iframeId, // 设置摄像头Id
        item.code, // 设置摄像头code
        item.code, // 设置摄像头code
        (result) => {
          if (result.ErrCode === 0) {
            this.domArr[index].success = true
          } else {
            this.domArr[index].success = false
          }
        },
        2
      )
    },
    // 保活接口
    keepAliveFn() {
      setTimeout(async () => {
        this.keepAliveFn()
      }, 30000)
      console.log('进入保活方法', dayjs().format('YYYY-MM-DD HH:mm:ss'))
      if (!window.playerToken) {
        console.log('window.playerToken为空,不进行保活')
        return
      }
      const apiUrl = `http://${this.ipAddress}:${this.port}/VIID/hadesadapter/user/keepalive`
      const requestOption = {
        method: 'POST',
        headers: {
          Authorization: window.playerToken,
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          }
          throw new Error('网络请求失败')
        })
        .then((res) => {
          const ErrCode = res.ErrCode
          if (ErrCode !== 0) {
            console.log('保活异常,重新获取token', 'res为:' + res, 'token为:' + window.playerToken)
            // this.getConfig()
          } else {
            console.log('保活正常', 'res为:' + res, 'token为:' + window.playerToken)
          }
        })
        .catch((error) => {
          console.log('保活接口调用服务器服务器连接异常error', error)
        })
    },
    refresh() {
      this.isShowDialog = false
    },
    // 打开云台
    reviewDetail(item) {
      this.isShowDialog = true
      this.deviceCode = item.deviceCode || item.code
      this.plid = item.plid || item.pIid
    },
  },
}
</script>

<style lang="scss" scoped>
.three-dim-multipal-player {
  ::v-deep .imosSdk-video {
    width: 100% !important;
    height: calc(100% - 28px) !important;
  }
}
.forVideo {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
